import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../exceptions.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../Unit.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../ranges/_Ranges.mjs';
import { Companion_instance1el8xrhi64v9a as Companion_instance } from './AbstractList.mjs';
import {
  arrayCopytctsywo3h7gj as arrayCopy,
  arrayOfNulls3cqbl98qmfq5b as arrayOfNulls,
  terminateCollectionToArray12671uhv05xea as terminateCollectionToArray,
} from './collectionJs.mjs';
import { get_lastIndexx0qsydpfv3mu as get_lastIndex } from './_Arrays.mjs';
import { fill3hcjvebk42tyx as fill } from './_ArraysJs.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { AbstractMutableList192xfq8ycgofs as AbstractMutableList } from './AbstractMutableListJs.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex_0 } from './CollectionsKt.mjs';
import { equals2au1ep9vhcato as equals } from '../js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { isArray1hxjqtqy632bc as isArray } from '../js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ensureCapacity($this, minCapacity) {
  if (minCapacity < 0)
    throw IllegalStateException().o('Deque is too big.');
  if (minCapacity <= $this.nj_1.length)
    return Unit_instance;
  if ($this.nj_1 === Companion_getInstance().pj_1) {
    var tmp = $this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = coerceAtLeast(minCapacity, 10);
    tmp.nj_1 = Array(size);
    return Unit_instance;
  }
  var newCapacity = Companion_instance.sa($this.nj_1.length, minCapacity);
  copyElements($this, newCapacity);
}
function copyElements($this, newCapacity) {
  // Inline function 'kotlin.arrayOfNulls' call
  var newElements = Array(newCapacity);
  var tmp0 = $this.nj_1;
  var tmp6 = $this.mj_1;
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = $this.nj_1.length;
  arrayCopy(tmp0, newElements, 0, tmp6, endIndex);
  var tmp0_0 = $this.nj_1;
  var tmp4 = $this.nj_1.length - $this.mj_1 | 0;
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex_0 = $this.mj_1;
  arrayCopy(tmp0_0, newElements, tmp4, 0, endIndex_0);
  $this.mj_1 = 0;
  $this.nj_1 = newElements;
}
function positiveMod($this, index) {
  return index >= $this.nj_1.length ? index - $this.nj_1.length | 0 : index;
}
function negativeMod($this, index) {
  return index < 0 ? index + $this.nj_1.length | 0 : index;
}
function incremented($this, index) {
  return index === get_lastIndex($this.nj_1) ? 0 : index + 1 | 0;
}
function decremented($this, index) {
  return index === 0 ? get_lastIndex($this.nj_1) : index - 1 | 0;
}
function copyCollectionElements($this, internalIndex, elements) {
  var iterator = elements.p1();
  var inductionVariable = internalIndex;
  var last = $this.nj_1.length;
  if (inductionVariable < last)
    $l$loop: do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!iterator.q1())
        break $l$loop;
      $this.nj_1[index] = iterator.r1();
    }
     while (inductionVariable < last);
  var inductionVariable_0 = 0;
  var last_0 = $this.mj_1;
  if (inductionVariable_0 < last_0)
    $l$loop_0: do {
      var index_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      if (!iterator.q1())
        break $l$loop_0;
      $this.nj_1[index_0] = iterator.r1();
    }
     while (inductionVariable_0 < last_0);
  $this.oj_1 = $this.oj_1 + elements.q2() | 0;
}
function removeRangeShiftPreceding($this, fromIndex, toIndex) {
  // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
  var index = fromIndex - 1 | 0;
  var copyFromIndex = positiveMod($this, $this.mj_1 + index | 0);
  // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
  var index_0 = toIndex - 1 | 0;
  var copyToIndex = positiveMod($this, $this.mj_1 + index_0 | 0);
  var copyCount = fromIndex;
  while (copyCount > 0) {
    var tmp0 = copyCount;
    var tmp2 = copyFromIndex + 1 | 0;
    // Inline function 'kotlin.comparisons.minOf' call
    var c = copyToIndex + 1 | 0;
    var segmentLength = Math.min(tmp0, tmp2, c);
    var tmp0_0 = $this.nj_1;
    var tmp2_0 = $this.nj_1;
    var tmp4 = (copyToIndex - segmentLength | 0) + 1 | 0;
    var tmp6 = (copyFromIndex - segmentLength | 0) + 1 | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = copyFromIndex + 1 | 0;
    arrayCopy(tmp0_0, tmp2_0, tmp4, tmp6, endIndex);
    copyFromIndex = negativeMod($this, copyFromIndex - segmentLength | 0);
    copyToIndex = negativeMod($this, copyToIndex - segmentLength | 0);
    copyCount = copyCount - segmentLength | 0;
  }
}
function removeRangeShiftSucceeding($this, fromIndex, toIndex) {
  // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
  var copyFromIndex = positiveMod($this, $this.mj_1 + toIndex | 0);
  // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
  var copyToIndex = positiveMod($this, $this.mj_1 + fromIndex | 0);
  var copyCount = $this.oj_1 - toIndex | 0;
  while (copyCount > 0) {
    var tmp0 = copyCount;
    var tmp2 = $this.nj_1.length - copyFromIndex | 0;
    // Inline function 'kotlin.comparisons.minOf' call
    var c = $this.nj_1.length - copyToIndex | 0;
    var segmentLength = Math.min(tmp0, tmp2, c);
    var tmp0_0 = $this.nj_1;
    var tmp2_0 = $this.nj_1;
    var tmp4 = copyToIndex;
    var tmp6 = copyFromIndex;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = copyFromIndex + segmentLength | 0;
    arrayCopy(tmp0_0, tmp2_0, tmp4, tmp6, endIndex);
    copyFromIndex = positiveMod($this, copyFromIndex + segmentLength | 0);
    copyToIndex = positiveMod($this, copyToIndex + segmentLength | 0);
    copyCount = copyCount - segmentLength | 0;
  }
}
function nullifyNonEmpty($this, internalFromIndex, internalToIndex) {
  if (internalFromIndex < internalToIndex) {
    fill($this.nj_1, null, internalFromIndex, internalToIndex);
  } else {
    fill($this.nj_1, null, internalFromIndex, $this.nj_1.length);
    fill($this.nj_1, null, 0, internalToIndex);
  }
}
function registerModification($this) {
  $this.u6_1 = $this.u6_1 + 1 | 0;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        // Inline function 'kotlin.emptyArray' call
        tmp.pj_1 = [];
        this.qj_1 = 10;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
function init_kotlin_collections_ArrayDeque(_this__u8e3s4) {
  Companion_getInstance();
  _this__u8e3s4.mj_1 = 0;
  _this__u8e3s4.oj_1 = 0;
}
var ArrayDequeClass;
function ArrayDeque() {
  if (ArrayDequeClass === VOID) {
    class $ extends AbstractMutableList() {
      q2() {
        return this.oj_1;
      }
      static rj() {
        Companion_getInstance();
        var $this = this.h7();
        init_kotlin_collections_ArrayDeque($this);
        $this.nj_1 = Companion_getInstance().pj_1;
        return $this;
      }
      n1() {
        return this.oj_1 === 0;
      }
      sj(element) {
        registerModification(this);
        ensureCapacity(this, this.oj_1 + 1 | 0);
        this.mj_1 = decremented(this, this.mj_1);
        this.nj_1[this.mj_1] = element;
        this.oj_1 = this.oj_1 + 1 | 0;
      }
      tj(element) {
        registerModification(this);
        ensureCapacity(this, this.oj_1 + 1 | 0);
        var tmp = this.nj_1;
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index = this.oj_1;
        tmp[positiveMod(this, this.mj_1 + index | 0)] = element;
        this.oj_1 = this.oj_1 + 1 | 0;
      }
      uj() {
        if (this.n1())
          throw NoSuchElementException().a2('ArrayDeque is empty.');
        registerModification(this);
        // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
        var internalIndex = this.mj_1;
        var element = this.nj_1[internalIndex];
        this.nj_1[this.mj_1] = null;
        this.mj_1 = incremented(this, this.mj_1);
        this.oj_1 = this.oj_1 - 1 | 0;
        return element;
      }
      vj() {
        return this.n1() ? null : this.uj();
      }
      wj() {
        if (this.n1())
          throw NoSuchElementException().a2('ArrayDeque is empty.');
        registerModification(this);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index = get_lastIndex_0(this);
        var internalLastIndex = positiveMod(this, this.mj_1 + index | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
        var element = this.nj_1[internalLastIndex];
        this.nj_1[internalLastIndex] = null;
        this.oj_1 = this.oj_1 - 1 | 0;
        return element;
      }
      i2(element) {
        this.tj(element);
        return true;
      }
      b5(index, element) {
        Companion_instance.z6(index, this.oj_1);
        if (index === this.oj_1) {
          this.tj(element);
          return Unit_instance;
        } else if (index === 0) {
          this.sj(element);
          return Unit_instance;
        }
        registerModification(this);
        ensureCapacity(this, this.oj_1 + 1 | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var internalIndex = positiveMod(this, this.mj_1 + index | 0);
        if (index < (this.oj_1 + 1 | 0) >> 1) {
          var decrementedInternalIndex = decremented(this, internalIndex);
          var decrementedHead = decremented(this, this.mj_1);
          if (decrementedInternalIndex >= this.mj_1) {
            this.nj_1[decrementedHead] = this.nj_1[this.mj_1];
            var tmp0 = this.nj_1;
            var tmp2 = this.nj_1;
            var tmp4 = this.mj_1;
            var tmp6 = this.mj_1 + 1 | 0;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex = decrementedInternalIndex + 1 | 0;
            arrayCopy(tmp0, tmp2, tmp4, tmp6, endIndex);
          } else {
            var tmp0_0 = this.nj_1;
            var tmp2_0 = this.nj_1;
            var tmp4_0 = this.mj_1 - 1 | 0;
            var tmp6_0 = this.mj_1;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex_0 = this.nj_1.length;
            arrayCopy(tmp0_0, tmp2_0, tmp4_0, tmp6_0, endIndex_0);
            this.nj_1[this.nj_1.length - 1 | 0] = this.nj_1[0];
            var tmp0_1 = this.nj_1;
            var tmp2_1 = this.nj_1;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex_1 = decrementedInternalIndex + 1 | 0;
            arrayCopy(tmp0_1, tmp2_1, 0, 1, endIndex_1);
          }
          this.nj_1[decrementedInternalIndex] = element;
          this.mj_1 = decrementedHead;
        } else {
          // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
          var index_0 = this.oj_1;
          var tail = positiveMod(this, this.mj_1 + index_0 | 0);
          if (internalIndex < tail) {
            var tmp0_2 = this.nj_1;
            var tmp2_2 = this.nj_1;
            // Inline function 'kotlin.collections.copyInto' call
            var destinationOffset = internalIndex + 1 | 0;
            arrayCopy(tmp0_2, tmp2_2, destinationOffset, internalIndex, tail);
          } else {
            var tmp0_3 = this.nj_1;
            // Inline function 'kotlin.collections.copyInto' call
            var destination = this.nj_1;
            arrayCopy(tmp0_3, destination, 1, 0, tail);
            this.nj_1[0] = this.nj_1[this.nj_1.length - 1 | 0];
            var tmp0_4 = this.nj_1;
            var tmp2_3 = this.nj_1;
            var tmp4_1 = internalIndex + 1 | 0;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex_2 = this.nj_1.length - 1 | 0;
            arrayCopy(tmp0_4, tmp2_3, tmp4_1, internalIndex, endIndex_2);
          }
          this.nj_1[internalIndex] = element;
        }
        this.oj_1 = this.oj_1 + 1 | 0;
      }
      u2(elements) {
        if (elements.n1())
          return false;
        registerModification(this);
        ensureCapacity(this, this.oj_1 + elements.q2() | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index = this.oj_1;
        var tmp$ret$0 = positiveMod(this, this.mj_1 + index | 0);
        copyCollectionElements(this, tmp$ret$0, elements);
        return true;
      }
      r2(index) {
        Companion_instance.i7(index, this.oj_1);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
        var internalIndex = positiveMod(this, this.mj_1 + index | 0);
        return this.nj_1[internalIndex];
      }
      j3(index, element) {
        Companion_instance.i7(index, this.oj_1);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var internalIndex = positiveMod(this, this.mj_1 + index | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
        var oldElement = this.nj_1[internalIndex];
        this.nj_1[internalIndex] = element;
        return oldElement;
      }
      t2(element) {
        return !(this.r4(element) === -1);
      }
      r4(element) {
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index = this.oj_1;
        var tail = positiveMod(this, this.mj_1 + index | 0);
        if (this.mj_1 < tail) {
          var inductionVariable = this.mj_1;
          if (inductionVariable < tail)
            do {
              var index_0 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              if (equals(element, this.nj_1[index_0]))
                return index_0 - this.mj_1 | 0;
            }
             while (inductionVariable < tail);
        } else {
          var tmp;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!this.n1()) {
            tmp = this.mj_1 >= tail;
          } else {
            tmp = false;
          }
          if (tmp) {
            var inductionVariable_0 = this.mj_1;
            var last = this.nj_1.length;
            if (inductionVariable_0 < last)
              do {
                var index_1 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                if (equals(element, this.nj_1[index_1]))
                  return index_1 - this.mj_1 | 0;
              }
               while (inductionVariable_0 < last);
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < tail)
              do {
                var index_2 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                if (equals(element, this.nj_1[index_2]))
                  return (index_2 + this.nj_1.length | 0) - this.mj_1 | 0;
              }
               while (inductionVariable_1 < tail);
          }
        }
        return -1;
      }
      c5(index) {
        Companion_instance.i7(index, this.oj_1);
        if (index === get_lastIndex_0(this)) {
          return this.wj();
        } else if (index === 0) {
          return this.uj();
        }
        registerModification(this);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var internalIndex = positiveMod(this, this.mj_1 + index | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
        var element = this.nj_1[internalIndex];
        if (index < this.oj_1 >> 1) {
          if (internalIndex >= this.mj_1) {
            var tmp0 = this.nj_1;
            var tmp2 = this.nj_1;
            var tmp4 = this.mj_1 + 1 | 0;
            // Inline function 'kotlin.collections.copyInto' call
            var startIndex = this.mj_1;
            arrayCopy(tmp0, tmp2, tmp4, startIndex, internalIndex);
          } else {
            var tmp0_0 = this.nj_1;
            // Inline function 'kotlin.collections.copyInto' call
            var destination = this.nj_1;
            arrayCopy(tmp0_0, destination, 1, 0, internalIndex);
            this.nj_1[0] = this.nj_1[this.nj_1.length - 1 | 0];
            var tmp0_1 = this.nj_1;
            var tmp2_0 = this.nj_1;
            var tmp4_0 = this.mj_1 + 1 | 0;
            var tmp6 = this.mj_1;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex = this.nj_1.length - 1 | 0;
            arrayCopy(tmp0_1, tmp2_0, tmp4_0, tmp6, endIndex);
          }
          this.nj_1[this.mj_1] = null;
          this.mj_1 = incremented(this, this.mj_1);
        } else {
          // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
          var index_0 = get_lastIndex_0(this);
          var internalLastIndex = positiveMod(this, this.mj_1 + index_0 | 0);
          if (internalIndex <= internalLastIndex) {
            var tmp0_2 = this.nj_1;
            var tmp2_1 = this.nj_1;
            var tmp6_0 = internalIndex + 1 | 0;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex_0 = internalLastIndex + 1 | 0;
            arrayCopy(tmp0_2, tmp2_1, internalIndex, tmp6_0, endIndex_0);
          } else {
            var tmp0_3 = this.nj_1;
            var tmp2_2 = this.nj_1;
            var tmp6_1 = internalIndex + 1 | 0;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex_1 = this.nj_1.length;
            arrayCopy(tmp0_3, tmp2_2, internalIndex, tmp6_1, endIndex_1);
            this.nj_1[this.nj_1.length - 1 | 0] = this.nj_1[0];
            var tmp0_4 = this.nj_1;
            var tmp2_3 = this.nj_1;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex_2 = internalLastIndex + 1 | 0;
            arrayCopy(tmp0_4, tmp2_3, 0, 1, endIndex_2);
          }
          this.nj_1[internalLastIndex] = null;
        }
        this.oj_1 = this.oj_1 - 1 | 0;
        return element;
      }
      a5() {
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.n1()) {
          registerModification(this);
          // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
          var index = this.oj_1;
          var tail = positiveMod(this, this.mj_1 + index | 0);
          nullifyNonEmpty(this, this.mj_1, tail);
        }
        this.mj_1 = 0;
        this.oj_1 = 0;
      }
      xj(array) {
        var tmp = array.length >= this.oj_1 ? array : arrayOfNulls(array, this.oj_1);
        var dest = isArray(tmp) ? tmp : THROW_CCE();
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index = this.oj_1;
        var tail = positiveMod(this, this.mj_1 + index | 0);
        if (this.mj_1 < tail) {
          var tmp0 = this.nj_1;
          // Inline function 'kotlin.collections.copyInto' call
          var startIndex = this.mj_1;
          arrayCopy(tmp0, dest, 0, startIndex, tail);
        } else {
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!this.n1()) {
            var tmp0_0 = this.nj_1;
            var tmp6 = this.mj_1;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex = this.nj_1.length;
            arrayCopy(tmp0_0, dest, 0, tmp6, endIndex);
            var tmp0_1 = this.nj_1;
            // Inline function 'kotlin.collections.copyInto' call
            var destinationOffset = this.nj_1.length - this.mj_1 | 0;
            arrayCopy(tmp0_1, dest, destinationOffset, 0, tail);
          }
        }
        var tmp_0 = terminateCollectionToArray(this.oj_1, dest);
        return isArray(tmp_0) ? tmp_0 : THROW_CCE();
      }
      i8() {
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.oj_1;
        var tmp$ret$0 = Array(size);
        return this.xj(tmp$ret$0);
      }
      toArray() {
        return this.i8();
      }
      j7(fromIndex, toIndex) {
        Companion_instance.f6(fromIndex, toIndex, this.oj_1);
        var length = toIndex - fromIndex | 0;
        if (length === 0)
          return Unit_instance;
        else if (length === this.oj_1) {
          this.a5();
          return Unit_instance;
        } else if (length === 1) {
          this.c5(fromIndex);
          return Unit_instance;
        }
        registerModification(this);
        if (fromIndex < (this.oj_1 - toIndex | 0)) {
          removeRangeShiftPreceding(this, fromIndex, toIndex);
          var newHead = positiveMod(this, this.mj_1 + length | 0);
          nullifyNonEmpty(this, this.mj_1, newHead);
          this.mj_1 = newHead;
        } else {
          removeRangeShiftSucceeding(this, fromIndex, toIndex);
          // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
          var index = this.oj_1;
          var tail = positiveMod(this, this.mj_1 + index | 0);
          nullifyNonEmpty(this, negativeMod(this, tail - length | 0), tail);
        }
        this.oj_1 = this.oj_1 - length | 0;
      }
    }
    initMetadataForClass($, 'ArrayDeque', $.rj);
    ArrayDequeClass = $;
  }
  return ArrayDequeClass;
}
//region block: exports
export {
  ArrayDeque as ArrayDeque2dzc9uld4xi7n,
};
//endregion

//# sourceMappingURL=ArrayDeque.mjs.map
